import { ocapiClient } from '../../../../api-clients/ocapi/client';
import { createFetchedData } from '../../../../utils/fetched-data/create-fetched-data';
import { createFetchedDataRecord } from '../../../../utils/fetched-data/create-fetched-data-record';
import { getCacheDuration } from '../../../../utils/get-cache-duration';
import { loadDataFromApi } from '../../../../utils/load-data-from-api';
import { updateObject } from '../../../../utils/object-utils';
import { loyaltyDomainStore } from '../../store';
export const loadLoyaltyMasterData = async () => {
    await loadDataFromApi({
        api: ocapiClient.instance.v1.loyalty.masterData.get,
        state: loyaltyDomainStore.data.masterData,
        cacheDuration: getCacheDuration('loyaltyMasterData'),
        onSuccess
    });
};
const onSuccess = (response, cacheDuration) => {
    const state = loyaltyDomainStore.data;
    updateObject(state.clubsById, createFetchedDataRecord(response.clubs, 'id', cacheDuration));
    updateObject(state.customPreferencesById, createFetchedDataRecord(response.customPreferences, 'id', cacheDuration));
    updateObject(state.educationLevelsById, createFetchedDataRecord(response.educationLevels, 'id', cacheDuration));
    updateObject(state.friendConfiguration, createFetchedData(response.friendConfiguration, cacheDuration));
    updateObject(state.genresById, createFetchedDataRecord(response.genres, 'id', cacheDuration));
    updateObject(state.interestsById, createFetchedDataRecord(response.interests, 'id', cacheDuration));
    updateObject(state.interestContactMethodsById, createFetchedDataRecord(response.interestContactMethods, 'id', cacheDuration));
    updateObject(state.occupationsById, createFetchedDataRecord(response.occupations, 'id', cacheDuration));
    updateObject(state.memberPhotoRequirements, createFetchedData(response.photoRequirements, cacheDuration));
    updateObject(state.sitesById, createFetchedDataRecord(response.sites, 'id', cacheDuration));
    return {
        clubIds: response.clubs.map(club => club.id),
        customPreferenceIds: response.customPreferences.map(preference => preference.id),
        educationLevelIds: response.educationLevels.map(level => level.id),
        genreIds: response.genres.map(genre => genre.id),
        interestIds: response.interests.map(interest => interest.id),
        interestContactMethodIds: response.interestContactMethods.map(method => method.id),
        occupationIds: response.occupations.map(occupation => occupation.id),
        siteIds: response.sites.map(site => site.id)
    };
};
